import Rating from './RatingTab';
export default Rating;
